import { NavLink } from 'react-router-dom'
import { LayoutDashboard, PawPrint, Clock, MessageCircle, Sparkles, Menu } from 'lucide-react'
import { classNames } from '../../lib/utils'
import { useRole } from '../../hooks/useRole'

const STAFF_TABS = [
  { to: '/',         icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/animals',  icon: PawPrint,        label: 'Animals' },
  { to: '/chat',     icon: MessageCircle,   label: 'Chat' },
  { to: '/hours',    icon: Clock,           label: 'Hours' },
]
const FOSTER_TABS = [
  { to: '/',         icon: LayoutDashboard, label: 'Home' },
  { to: '/animals',  icon: PawPrint,        label: 'My Animals' },
  { to: '/chat',     icon: MessageCircle,   label: 'Chat' },
  { to: '/support',  icon: Sparkles,        label: 'Support' },
]

export default function BottomNav({ onMoreClick }) {
  const { isFoster } = useRole()
  const tabs = isFoster ? FOSTER_TABS : STAFF_TABS

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 frosted-glass safe-bottom">
      <div className="flex items-stretch justify-around max-w-lg mx-auto" style={{ height: 'var(--bottom-nav-height)' }}>
        {tabs.map(tab => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.to === '/'}
            className={({ isActive }) => classNames(
              'flex flex-col items-center justify-center gap-0.5 flex-1 text-[0.625rem] font-semibold tracking-wide transition-colors',
              isActive ? 'text-primary' : 'text-outline'
            )}
          >
            {({ isActive }) => (
              <>
                <tab.icon size={22} strokeWidth={isActive ? 2 : 1.5} />
                <span>{tab.label}</span>
              </>
            )}
          </NavLink>
        ))}
        {/* Fosters get exactly 4 tabs — no More button */}
        {!isFoster && (
          <button
            onClick={onMoreClick}
            className="flex flex-col items-center justify-center gap-0.5 flex-1 text-[0.625rem] font-semibold tracking-wide text-outline"
          >
            <Menu size={22} strokeWidth={1.5} />
            <span>More</span>
          </button>
        )}
      </div>
    </nav>
  )
}
